/**
 * Created by olga on 14.11.2022
 */

const UnmergeableUnitHintContent = function (options) {
    this.unit = options.unit;

    this.doNotBlock = {
        x: this.unit.dragX,
        y: this.unit.dragY
    };
};

UnmergeableUnitHintContent.prototype.hasSameContent = function (options) {
    return Unit.Equals(this.unit, options.unit);
};

UnmergeableUnitHintContent.isApplicable = function (options) {
    const isTutorialActive = cleverapps.tutorial.isActive() || (Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive());
    return options.wrongMerged && !isTutorialActive;
};

UnmergeableUnitHintContent.prototype.getMessages = function () {
    let messages;
    if (this.unit.isLast()) {
        messages = [{ text: Messages.get("Merge.MaxStage") }];
    } else {
        messages = [
            { text: Messages.get("CenterHint.merge.unmergeableUnit") }
        ];
    }
    return messages;
};
